<template>
  <div class="space-y-8 my-12">
    <Card 
      v-for="(cardData, i) in enhanceFeatureData" 
      v-bind="cardData"
      :testimonialData="testimonials[cardData.order]"
      :key="`cardData-${i}`"
    />
</div>
</template>

<script>
import Card from './Card.vue';
import { mapState } from "vuex";
import NeedsSVG from './SVG/NeedsMatches'

export default {
  components: { Card, NeedsSVG },
  data: () => ({
    featuresData : [
      {
        order: "first",
        image: "https://cdn.sportsrecruits.com/assets/Athlete-Profile.svg",
        header: "A Transparent Recruiting Process",
        subHeader: "Get the play-by-play on profile views and college engagement. Target your recruiting efforts more effectively and save time by knowing when a college has viewed you.",
        proFeatures: [
          "Get text updates and emails on which colleges view your profile, transcripts, and press links. ",
          "Know which colleges are viewing your video — whether it's been uploaded directly to the platform, or embedded from YouTube, Vimeo, or Hudl.",
          "Trackable profile links are automatically added to your messages so that you can understand which colleges are clicking and engaging with your outreach."
        ],
        freeFeatures: [
          "Locked profile views."
        ],
      },
      {
        order: "second",
        image: "https://cdn.sportsrecruits.com/assets/Largest-Network.svg",
        header: "The Largest Recruiting Network at Your Fingertips",
        subHeader: "Drive engagement to your profile with access to every college coach in the country.",
        proFeatures: [
          "Message any coach in the U.S. directly with a click.",
          "Avoid the hassle of digging through individual school websites or using potentially dated contact information. Up-to-date college coach contact information is built right into our Messaging System.",
          "Send as many messages as you need with unlimited sends."
        ],
        freeFeatures: ["Publish videos and display your profile."],
      },
      {
        order: "third",
        image: "https://cdn.sportsrecruits.com/assets/Foam-Hand.svg",
        header: "Everything You Need To Get Recruited, All in One Place",
        subHeader: "The recruiting process is overwhelming. With Pro,  you have everything you need to stay on track and achieve your goals.",
        proFeatures: ["Simplify your recruiting journey. Consolidate emails, spreadsheets, coach directories, Google searches, video hosting, playlist tools, and everything in between, into one platform."
        ],
        freeFeatures: ["Publish a recruiting profile and search basic college information."],
      },
    ]
  }),
  computed: {
    ...mapState("pricing", {
      rosterNeedsEnabled: (state) => state.rosterNeedsEnabled,
      testimonials: (state) => state.testimonials,
      needsCount: (state) => state.rosterNeedsEnabled ? state.proFeatures.needsFilter.needsCount : null,
    }),
    enhanceFeatureData() {
      if(this.rosterNeedsEnabled) {
        this.featuresData.splice(2, 0,  {
          order: "",
          image: NeedsSVG,
          header: "Personalized Matches In One Click",
          subHeader: "Optimize your school research with Roster Needs data and see what roster spots college coaches are recruiting for and if you’re a fit.",
          proFeatures: [
            "In one click, access every school with open roster spots that match your athletic and academic profile.", 
            `Filter your college search results to uncover over ${this.needsCount} open roster spots that colleges have published themselves.`,
            "Combine Roster Needs with other athletic, academic, and social filters to narrow down and find your best-fit school."
          ],
          freeFeatures: ["See Roster Needs on school profiles."],
        });
      }

      return this.featuresData
    }
  }
}
</script>

<style>

</style>